import React from 'react'
import { Navbar } from "react-bootstrap";

export const Footer = () => {
    return (
        <Navbar  bg="dark" className=" d-flex justify-content-center">
            <i className="mr-1 far fa-copyright" />   All Rigth's reserve
        </Navbar>
    )
}
